import { DocContent } from '../docsData';

const doc: DocContent = {
  title: 'MCP servers',
  content: `
An MCP server connection lets agents call the tools of any remote MCP server: Notion, Atlassian, Sentry, an internal tool your team runs, anything that speaks MCP over HTTP. Each step calls only the tools you tick for it.

---

## Connect a server

1. Open the **Agents** page and find **Connections**. Choose **MCP server**, give the connection a name (for example \`ops-notion\`), and paste the server's URL (for example \`https://mcp.notion.com/mcp\`).
2. Keep **Sign in (OAuth)** selected and click **Sign in**. You're sent to the server to approve Pliable, then back here.
3. Pliable lists the server's tools on the connection's page.

Most servers let Pliable register itself. If yours asks for an OAuth client instead, create one in the server's settings with the redirect URL shown under the form, then paste its client ID (and secret, if it gave one) before you sign in.

If the server takes a fixed token instead of a sign-in, choose **Token** and paste it. Pliable sends it as \`Authorization: Bearer <token>\`.

The URL must be public and use https.

---

## Give a step its tools

On a step, add the connection under **Tools** and tick the tools it may call. Tools the server says only read are ticked to start with; the rest are marked **may change things**. That label is the server's own claim, so check what a tool does before you tick it.

\`\`\`json
{ "connection": "ops-notion", "capability": "tools.use", "params": { "tools": ["search", "fetch"] } }
\`\`\`

---

## When the server changes

When the server adds, renames or removes tools, open the connection and click **Refresh tools**. A step that names a tool the server no longer lists can't be saved until you untick it.

Pliable keeps the sign-in current. If the server revokes Pliable's access, delete the connection and sign in again.
`,
};

export default doc;
